// extracted by mini-css-extract-plugin
export default {"form":"LTLB0","main":"aLX2a","actions":"JnIPi","action":"HYFzz"};